export default {
  en: "English",
  pt: "Portugues (brasil)"
};
